/**
 * Shared search-field behavior:
 * - Submit (icon / Enter) only when input has non-whitespace text
 * - Clearing input after an active search auto-applies empty search (full results)
 */

export const hasSearchText = (value) => String(value ?? "").trim().length > 0;

export const hasAppliedSearch = (appliedValue) =>
  String(appliedValue ?? "").trim().length > 0;

/**
 * @param {string} inputValue - current input
 * @param {string} appliedValue - last applied search sent to API / URL
 * @returns {{ shouldApply: boolean, nextApplied: string | null }}
 *   nextApplied: string to apply, or null if no action
 */
export const getSearchSubmitAction = (inputValue, appliedValue) => {
  const trimmed = String(inputValue ?? "").trim();
  if (trimmed.length > 0) {
    return { shouldApply: true, nextApplied: trimmed };
  }
  if (hasAppliedSearch(appliedValue)) {
    return { shouldApply: true, nextApplied: "" };
  }
  return { shouldApply: false, nextApplied: null };
};

/**
 * Returns true when icon click / Enter should run submit handler.
 */
export const canTriggerSearchSubmit = (inputValue) => hasSearchText(inputValue);

/**
 * When input is cleared but a search was active, auto-apply empty search.
 */
export const shouldAutoClearSearch = (inputValue, appliedValue) =>
  !hasSearchText(inputValue) && hasAppliedSearch(appliedValue);
